import React from 'react';
function CornerTopLeftRadius({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M14.1665 5.83329L10.8481 5.83329C8.07845 5.83329 5.83317 8.07857 5.83317 10.8483L5.83317 14.1666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CornerTopLeftRadius;
